if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  setTimeout(() => {
    const btn = document.querySelector(".btn[bss-b2b-cart-trigger-added]");
    if (btn) {
      btn.addEventListener(
        "click",
        function (e) {
          this.style.opacity = "0.5";
          this.style.pointerEvents = "none";
        },
        true
      );
    }
  }, 2000);
}

function debounce(func, delay) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => func(...args), delay);
  };
}

const updateCartNote = debounce((note) => {
  fetch("/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ note }),
  })
    .then((response) => response.json())
    .then((data) => console.log("Cart note updated:", data.note))
    .catch((error) => console.error("Error updating cart note:", error));
}, 500);

document.addEventListener("DOMContentLoaded", () => {
  if (typeof BSS_B2B !== "undefined") {
    updateCartNote("");
    document
      .getElementById("bss-cart-note-textarea")
      ?.addEventListener("input", (event) => {
        updateCartNote(event.target.value);
      });
  }
});


if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  const priceElement = document.querySelector("#ProductPrice");
  
  if (priceElement) {
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
        if (mutation.type === "childList" && mutation.target.id === "ProductPrice" ) {
          const productForm = document.querySelector("[bss-b2b-main-product-form]");
          BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {productForm});
        }
      });
    });
  
    observer.observe(priceElement, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }
}